module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 bg-lightest pt-4 pb-4"
  }, [(_vm.getIsDownloadingInvoiceList) ? _c('div', {
    staticClass: "text-center fs-large dark bold mb-4"
  }, [_vm._v("\n        Loading\n    ")]) : (!_vm.getInvoiceList.result || _vm.getInvoiceList.result.length == 0) ? _c('div', {
    staticClass: "text-center fs-large dark bold mb-4"
  }, [_vm._v("\n        You have no invoices.\n    ")]) : _c('div', [_c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end mb-4"
  }, [(_vm.getInvoiceList.pageInfo && _vm.getInvoiceList.pageInfo.pageCount > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.getInvoiceList.pageInfo.totalItemCount,
      "items-per-page": 20,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.getReservationsPaginated
    },
    model: {
      value: (_vm.pagination),
      callback: function($$v) {
        _vm.pagination = $$v
      },
      expression: "pagination"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.getInvoiceList.result,
      "showNoDataMessage": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end mt-4"
  }, [(_vm.getInvoiceList.pageInfo && _vm.getInvoiceList.pageInfo.pageCount > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.getInvoiceList.pageInfo.totalItemCount,
      "items-per-page": 20,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.getReservationsPaginated
    },
    model: {
      value: (_vm.pagination),
      callback: function($$v) {
        _vm.pagination = $$v
      },
      expression: "pagination"
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4576138a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4576138a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/InvoiceList.vue
// module id = 1845
// module chunks = 0